const entries=new Map(),listeners=new Set();
let loader=null;
export const pagingKey=(storeId,phone)=>{
  let p=String(phone||"").replace(/\D/g,"").replace(/^55(?=\d{10,11}$)/,"");
  if(p.length===10)p=p.slice(0,2)+"9"+p.slice(2);
  return `${Number(storeId)}:${p}`;
};
export function historyState(storeId,phone){return entries.get(pagingKey(storeId,phone));}
export function publishHistoryState(storeId,phone,state){
  entries.set(pagingKey(storeId,phone),state);listeners.forEach(fn=>fn());
}
export function subscribeHistory(fn){listeners.add(fn);return()=>listeners.delete(fn);}
export function setHistoryPageLoader(fn){loader=fn;}
export function clearHistoryPages(){entries.clear();listeners.forEach(fn=>fn());}
export function loadOlderHistory(storeId,phone){return loader?.({storeId,phone,older:true});}
